import { observable } from '@/libs/state'
import type { TeamMember } from './domain/member'
import type { TimeOffBalance, TimeOffRequest } from './domain/timeoff'
import type { HistoryEntry } from '@/features/shared/domain/history'

const members$ = observable<TeamMember[]>([])
const activeMember$ = observable<TeamMember | null>(null)
const timeOffRequests$ = observable<TimeOffRequest[]>([])
const ownTimeOffRequests$ = observable<TimeOffRequest[]>([])
const teamTimeOffRequests$ = observable<TimeOffRequest[]>([])
const activeTimeOffRequest$ = observable<TimeOffRequest | null>(null)
const balances$ = observable<TimeOffBalance[]>([])
const deptMemberIds$ = observable<string[]>([])
const memberHistory$ = observable<HistoryEntry[]>([])
const timeOffHistory$ = observable<HistoryEntry[]>([])
const membersListVersion$ = observable<number>(0)
const timeOffListVersion$ = observable<number>(0)

const refreshMembersList = () => membersListVersion$.set(v => v + 1)
const refreshTimeOffList = () => timeOffListVersion$.set(v => v + 1)

export {
	members$,
	activeMember$,
	timeOffRequests$,
	ownTimeOffRequests$,
	teamTimeOffRequests$,
	activeTimeOffRequest$,
	balances$,
	deptMemberIds$,
	memberHistory$,
	timeOffHistory$,
	membersListVersion$,
	timeOffListVersion$,
	refreshMembersList,
	refreshTimeOffList,
}
